import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  RacunFilterDto,
  SubscriptionPackage,
  TipRacuna,
  VrstaRacuna
} from '@kodit/core/data-api';
import { AuthService } from '@kodit/core/services';
import { Subscription } from 'rxjs';
import { RacunTableService } from '../racun-table.service';
import { RacunFilterService } from '../racun-filter/racun-filter.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'kodit-ulazni-racun-page',
  templateUrl: './ulazni-racun-page.component.html',
  styleUrls: ['./ulazni-racun-page.component.scss'],
})
export class UlazniRacunPageComponent implements OnInit, OnDestroy {
  /** Subs */
  private _subs = new Subscription();

  /** Conditional props */
  hasBesplatniPaket: boolean = false;

  /** Tabs props */
  tipUlaznaFaktura = TipRacuna.ULAZNA_FAKTURA;
  tipAvansniRacun = TipRacuna.AVANSNI_RACUN;
  tipOdobrenje = TipRacuna.DOKUMENT_O_SMANJENJU;
  tipZaduzenje = TipRacuna.DOKUMENT_O_POVECANJU;
  vrstaRacunaUlazni = VrstaRacuna.ULAZNI;
  strankaId: number | undefined;

  activeIndex: number = 0;
  selectedTipRacuna : TipRacuna;

  @Input() strankaPib: string | undefined;
  @Input() jeFizickoLice: boolean | undefined;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _tableService: RacunTableService,
    private _authService: AuthService,
    private _racunFilterService: RacunFilterService,
  ) {
    this._route.params.subscribe((params) => {
      if (params['strankaId']) {
        this.strankaId = Number.parseInt(params['strankaId']);
      }
    });
  }

  ngOnInit(): void {
    this.hasBesplatniPaket =
      this._authService.hasPackage(SubscriptionPackage[SubscriptionPackage.BESPLATNO]) &&
      !this._authService.hasPackage(SubscriptionPackage[SubscriptionPackage.ROOT]);

    this._route.queryParams.subscribe((params) => {
      if (params.activeTab) {
        const activeTabIdx = Number.parseInt(params.activeTab);
        if (!isNaN(activeTabIdx) && this.allowedIndecies.includes(activeTabIdx)) {
          this.activeIndex = activeTabIdx;
          this._tableService.setActiveTab = activeTabIdx;
        }
      }
      this._initFilterServiceForTab(this.activeIndex);
    });

    this._subs.add(
      this._tableService.getActiveTab.subscribe((tabIndex) => {
        this.activeIndex = tabIndex;
        this._initFilterServiceForTab(tabIndex);
      })
    );
  }

  get sefTabIndex(): number {
    return this.hasBesplatniPaket ? 4 : 5;
  }

  get allowedIndecies(): number[] {
    const baseIndecies = [0, 1, 2, 3, 4, 5];
    return this.jeFizickoLice
      ? baseIndecies.filter((i) => i !== this.sefTabIndex)
      : baseIndecies;
  }

  private _initFilterServiceForTab(tabIndex: number): void {
    this._racunFilterService.init({
      vrstaRacuna: VrstaRacuna.ULAZNI,
      tipRacuna: this._tipRacunaForTab(tabIndex),
      jePravnoLice: this.strankaId != undefined,
    });
  }

  private _tipRacunaForTab(tabIndex: number): TipRacuna {
    switch (tabIndex) {
      case 0:
        return TipRacuna.ULAZNA_FAKTURA;
      case 1:
        return TipRacuna.AVANSNI_RACUN;
      case 2:
        return TipRacuna.DOKUMENT_O_SMANJENJU;
      case 3:
        return TipRacuna.DOKUMENT_O_POVECANJU;
      default:
        return TipRacuna.EMPTY;
    }
  }

  handleIndexChange(tabIndex: number) {
    this._tableService.setActiveTab = tabIndex;
    this._initFilterServiceForTab(tabIndex);
    // ToDo: dodati tutorials u zavisnosti od taba
    switch (tabIndex) {
      case 0:
        this.selectedTipRacuna = TipRacuna.ULAZNA_FAKTURA;
        break;
      case 1:
        this.selectedTipRacuna = TipRacuna.AVANSNI_RACUN;
        break;
      case 2:
        this.selectedTipRacuna = TipRacuna.DOKUMENT_O_SMANJENJU;
        break;
      case 3:
        this.selectedTipRacuna = TipRacuna.DOKUMENT_O_POVECANJU;
        break;
      default: this.selectedTipRacuna = TipRacuna.EMPTY; break;
    }
  }

  ngOnDestroy(): void {
    // reset active tab if we leaving the page
    const nextUrl = this._router.routerState.snapshot.url;
    if (nextUrl.indexOf('ulazni-racuni') === -1 && nextUrl.indexOf('sef-obavestenja') === -1) {
      this._tableService.resetActiveTab();
    }
    this._subs.unsubscribe();
  }

  public readonly VrstaRacuna = VrstaRacuna;
  public readonly TipRacuna = TipRacuna;
}
